import React from "react";
import "./StatsSection.css";

const stats = [
  { value: "10,000+", label: "Happy Customers" },
  { value: "5+", label: "Locations in Chennai" },
  { value: "1.79%", label: "Lowest Rate" },
  { value: "5 Min", label: "Instant Transfer" },
  { value: "24/7", label: "Always Available" },
  { value: "100%", label: "Satisfaction Rate" },
];

const StatsSection = () => {
  return (
    <section className="stats-section">
      {/* The Diagonal Background Pattern */}
      <div className="stats-diagonal-overlay" />

      <div className="stats-container">
        <div className="stats-grid">
          {stats.map((s, i) => (
            <div 
              key={s.label} 
              className="stat-card"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <p className="stat-value">{s.value}</p>
              <p className="stat-label">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;